import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectAllocatedExpensesBudgetRequestFailure({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditProjectAllocatedExpensesBudgetRequestPending({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditProjectAllocatedExpensesBudgetRequestSuccess({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
